var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHistoricAudioComment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 14.89C5.59 14.89 5.25 14.55 5.25 14.14V9.84998C5.25 9.43998 5.59 9.09998 6 9.09998C6.41 9.09998 6.75 9.43998 6.75 9.84998V14.14C6.75 14.56 6.41 14.89 6 14.89Z",
    fill: "#455CC7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 16.3199C8.59 16.3199 8.25 15.9799 8.25 15.5699V8.42993C8.25 8.01993 8.59 7.67993 9 7.67993C9.41 7.67993 9.75 8.01993 9.75 8.42993V15.5699C9.75 15.9899 9.41 16.3199 9 16.3199Z",
    fill: "#455CC7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 17.75C11.59 17.75 11.25 17.41 11.25 17V7C11.25 6.59 11.59 6.25 12 6.25C12.41 6.25 12.75 6.59 12.75 7V17C12.75 17.41 12.41 17.75 12 17.75Z",
    fill: "#455CC7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15 16.3199C14.59 16.3199 14.25 15.9799 14.25 15.5699V8.42993C14.25 8.01993 14.59 7.67993 15 7.67993C15.41 7.67993 15.75 8.01993 15.75 8.42993V15.5699C15.75 15.9899 15.41 16.3199 15 16.3199Z",
    fill: "#455CC7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18 14.89C17.59 14.89 17.25 14.55 17.25 14.14V9.84998C17.25 9.43998 17.59 9.09998 18 9.09998C18.41 9.09998 18.75 9.43998 18.75 9.84998V14.14C18.75 14.56 18.41 14.89 18 14.89Z",
    fill: "#455CC7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15 22.75H9C3.57 22.75 1.25 20.43 1.25 15V9C1.25 3.57 3.57 1.25 9 1.25H15C20.43 1.25 22.75 3.57 22.75 9V15C22.75 20.43 20.43 22.75 15 22.75ZM9 2.75C4.39 2.75 2.75 4.39 2.75 9V15C2.75 19.61 4.39 21.25 9 21.25H15C19.61 21.25 21.25 19.61 21.25 15V9C21.25 4.39 19.61 2.75 15 2.75H9Z",
    fill: "#455CC7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistoricAudioComment);
export default __webpack_public_path__ + "static/media/HistoricAudioComment.dbb25360.svg";
export { ForwardRef as ReactComponent };